const styles = theme => ({
    divider: {
        marginRight: 20,
        color: theme.palette.primary.light
    }
});

export default styles;